/* global $ */
/* eslint no-unused-vars: 0 */

const $html = $('html');
const $menuOverlay = $.$body.find('.menuOverlay');
const $menuOverlayInner = $menuOverlay.find('.main-mobile-menu-inner');
let lastScrollPosition = 0;
const mainNavItems = $menuOverlay.find('.menu-item-has-children');
const arrowLink = `<button class='arrow'>
                            <svg width='24' height='24' viewBox='0 0 24 24' fill='none'>
  <path fill-rule='evenodd' clip-rule='evenodd' d='M3.3291 8.99487L4.92013 7.34229L11.9996 13.6952L19.0791 7.34229L20.6701 8.99472L11.9996 17.0001L3.3291 8.99487Z' fill='white'/></svg>
                        </button>`;
let activeMenuItem;
mainNavItems.each((i, item) => {
  const menu = $(item).find('.sub-menu');
  if (!$(item).find('.arrow').length) {
    $(arrowLink).insertBefore(menu, null);
  }
});

$(document).on('click', '.menuOverlay .arrow', (e) => {
  const target = $(e.target);
  if (target.closest('.arrow').length) {
    activeMenuItem = target.closest('.arrow').parent();
    if (window.innerWidth < 1200) {
      if (!activeMenuItem.hasClass('active')) {
        activeMenuItem
          .addClass('active')
          .find('.sub-menu')
          .slideDown();
      } else {
        activeMenuItem
          .removeClass('active')
          .find('.sub-menu')
          .slideUp();
      }
    }
  }
});

function openMenu(e) {
  lastScrollPosition = $('html, body').scrollTop();
  $menuOverlay.addClass('menu--open temp-high-z');
  e.preventDefault();
  $html.addClass('noScroll overlay-active');
  $menuOverlayInner.scrollTop(0);
  // $('html, body').animate({ scrollTop: 0 }, 50);
  $menuOverlay.attr('aria-hidden', 'false');
}

function closeMenu(e) {
  $html.removeClass('noScroll overlay-active');
  $menuOverlay.removeClass('menu--open');
  e.preventDefault();
  e.stopPropagation();
  $menuOverlay.attr('aria-hidden', 'true');
  // $('html, body').animate({ scrollTop: lastScrollPosition }, 50);
  setTimeout(() => {
    // eslint-disable-line
    $menuOverlay.removeClass('temp-high-z');
  }, 200);
}

$.$body
  .on('click', '#btn-menu', openMenu)
  .on('click', '#btn-menu-close', closeMenu);

// close on ESC
document.addEventListener('keyup', (ev) => ev.keyCode === 27 && closeMenu(ev));
